import React from "react";
import I18n from "i18n-js";

import ProgressBar from "../../../commons/ProgressBar";

const Objective = ({ objective, selected, onClick }) => {

  const progress = Math.round(objective?.progress * 100.0);

  const handleClick = (event) => {
    event.preventDefault();
    onClick && onClick(objective);
  }

  return (
    <div className={`summary-objective ${selected ? "selected" : ""}`} onClick={handleClick}>
      <span className="title">{`${objective.index}. ${objective.title}`}</span>
      <div className="tasks-progress">
        <ProgressBar value={progress} />
        <span className="indicator">
          {I18n.t("pdp.objectives.selector.progress.indicator", { progress: progress })}
        </span>
      </div>
    </div>
  );
}

export default Objective;
